import * as React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/layout';
import SEO from '../components/seo';

interface BlogPostTemplateProps {
  data: {
    site: {
      siteMetadata: {
        title: string;
      };
    };
    markdownRemark: {
      id: string;
      excerpt: string;
      html: string;
      frontmatter: {
        title: string;
        date: string;
      };
    };
  };
  //   pageContext: {
  //     previous: any;
  //     next: any;
  //   };
  location: Location;
}

const BlogPostTemplate = ({ data, location }: BlogPostTemplateProps) => {
  console.log('data :', data);
  const post = data.markdownRemark;
  const siteTitle = data.site.siteMetadata?.title || `Title`;
  // const { previous, next } = data;

  return (
    <Layout location={location} title={siteTitle}>
      {/* <SEO title={post.frontmatter.title} /> */}
      <article className="blog-post" itemScope itemType="http://schema.org/Article">
        <h2 itemProp="headline">{post.frontmatter.title}</h2>
        <p>{post.frontmatter.date}</p>
        <section dangerouslySetInnerHTML={{ __html: post.html }} itemProp="articleBody" className="blog-post" />
      </article>
    </Layout>
  );
};

export default BlogPostTemplate;

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      frontmatter {
        title
        date(formatString: "DD.MM.YYYY")
      }
    }
  }
`;
